<template>
  <div class="newCustomer">
    <v-container class="my-5">
      <v-row justify="center">
        <v-col>
          <v-card>
            <v-card-title>
              New Customer - {{ customer.name }}

            <div class="flex-grow-1"></div>
              <v-btn icon @click="closeEdit">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row v-for="(value, key) in customer" :key="key">
                <!-- key -->
                <v-col class="mt-2 text-right font-weight-light">{{ key }}</v-col>

                <!-- value -->
                <v-col class="text-left">
                  <v-text-field solo class="my-0" v-model="customer[key]" dense></v-text-field>
                </v-col>
              </v-row>

              <v-row v-if="errorMessage">
                <v-col>
                  {{ errorMessage }}
                </v-col>
              </v-row>

              <v-row>
                <div class="flex-grow-1"></div>

                <v-col class="text-right">
                  <v-btn class="mr-3" color="success" @click="saveChanges" :loading="loading">
                    Save
                  </v-btn>
                  <VerifyDialog
                    :propBtnColor="'red'"
                    :propBtnDisabled="loading"
                    :propBtnDark="true"
                    :propActionBtnName="'Delete'"
                    :propTitle="`Delete customer ${customer.name}?`"
                    />
                  <v-btn @click="closeEdit" :disabled="loading">
                    Cancel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'NewCustomer',

  data: () => ({
    loading: false,
    customer: {
      name: '',
      email: '',
      phone1: '',
      phone2: '',
      address1: '',
      address2: '',
      region: '',
      zipcode: '',
      country: '',
      tripletexCustomerNo: ''
    },
    errorMessage: ''
  }),

  mounted () {
    this.getNewCustomerFromRouteQuery()
  },

  methods: {
    getNewCustomerFromRouteQuery () {
      console.log(`getNewCustomerFromRouteQuery triggered: ${this.$route.query.newCustomer}`)
      this.customer.name = this.$route.query.newCustomer
    },

    async saveChanges () {
      console.log('saveChanges triggered')

      this.loading = true

      try {
        await axios.post(process.env.VUE_APP_API_URL + '/customers', this.customer)

        this.loading = false
        this.$store.commit('setSnackbarText', 'Successfully created customer ' + this.customer.name)
        this.$store.commit('setSnackbarColor', 'success')
        this.$store.commit('setSnackbar', true)
        this.$router.push('/')
      } catch (err) {
        console.error('Error trying to saveChanges axios.post()', err)
        this.errorMessage = err
        this.loading = false
      }
    },

    closeEdit () {
      console.log('closeEdit triggered')
    }
  }
}
</script>
